export const refContainersOptions = [
	{ value: null, label: 'doesn-t-matter' },
	{ value: true, label: 'there-is' },
];

export const loadingUnloadingTypeOptions = [
	{ value: false, label: 'manual' },
	{ value: true, label: 'mechanized' },
];

export const inspectRoomsOptions = [
	{ value: null, label: 'doesn-t-matter' },
	{ value: true, label: 'there-is' },
];
